import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
      opacity='1'
      color='black'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M7.182 8L11 11.89 9.91 13 5 8l4.91-5L11 4.11 7.182 8z'
      ></path>
    </svg>
  )
}

export default Icon
